

import { useState, useEffect } from "react"
import { Box, Drawer, IconButton, Button } from "@mui/material"
import { useTranslation } from "react-i18next"
import profilecross from "../../../../assets/profilecross.svg"
import CustomText, { textStyles } from "../../../../components/CustomText"
import CustomButton from "../../../../components/CustomButton"
import save from "../../../../assets/save.svg" // Assuming this is for the "Apply" button icon
import {toast} from "react-hot-toast"
// Props: open, onClose, initialFilters (current filters from parent), onApplyFilters, onClearAllFilters
const FilterDrawer = ({ open, onClose, initialFilters, onApplyFilters, onClearAllFilters }) => {
  const { t } = useTranslation()
  // Internal state for filters, allowing changes without immediately affecting parent
  const [tempFilters, setTempFilters] = useState(initialFilters)

  // Update tempFilters when initialFilters prop changes (e.g., when drawer opens or parent updates)
  useEffect(() => {
    setTempFilters(initialFilters)
  }, [initialFilters])


// const plans = [
//   { label: t("filterDrawer.plan.enterprise"), value: "enterprise" },
//   { label: t("filterDrawer.plan.advance"), value: "advance" },
//   { label: t("filterDrawer.plan.pro"), value: "pro" },
//   { label: t("filterDrawer.plan.basic"), value: "basic" },
// ]

const statuses = [
  { label: t("filterDrawer.statusOptions.received"), value: "received" },
  { label: t("filterDrawer.statusOptions.pending"), value: "pending" },
]
  const handleDateChange = (e) => {
    setTempFilters({ ...tempFilters, [e.target.name]: e.target.value })
  }

  const handlePlanChange = (plan) => {
    const updatedPlans = tempFilters.plan_name.includes(plan)
      ? tempFilters.plan_name.filter((p) => p !== plan)
      : [...tempFilters.plan_name, plan]
    setTempFilters({ ...tempFilters, plan_name: updatedPlans })
  }

  const handleStatusChange = (status) => {
    const updatedStatuses = tempFilters.commission_status.includes(status)
      ? tempFilters.commission_status.filter((s) => s !== status)
      : [...tempFilters.commission_status, status]
    setTempFilters({ ...tempFilters, commission_status: updatedStatuses })
  }

const applyFilters = () => {
  const start = tempFilters.date_from;
  const end = tempFilters.date_to;

  // Date validation
  if (start && end && new Date(end) < new Date(start)) {
    toast.error(t("filterDrawer.errors.endDateBeforeStart"));
    return; // ❌ Stop applying filters
  }

  console.log("🟦 Applying filters from drawer:", tempFilters);
  onApplyFilters(tempFilters);
  onClose();
};


  const clearAllFilters = () => {
    const cleared = {
      // plan_name: [],
      commission_status: [],
      date_from: "",
      date_to: "",
    }
    setTempFilters(cleared) // Reset internal state
    onClearAllFilters(cleared) // Notify parent to clear
    onClose()
  }

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: { xs: "100%", sm: 400, md: 550 },
          backgroundColor: "#E7EBEE",
        },
      }}
    >
      {/* Sticky Header */}
      <Box
        sx={{
          position: "sticky",
          top: 0,
          backgroundColor: "#E7EBEE",
          zIndex: 10,
          px: 2,
          py: 1.5,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <IconButton onClick={onClose}>
            <img src={profilecross || "/placeholder.svg"} alt="close" />
          </IconButton>
          <CustomText sx={{ ...textStyles.h1, fontSize: 20, fontWeight: 600, color: "#2C384C" }}>
            {t("filterDrawer.title")}
          </CustomText>
        </Box>
      </Box>

      <Box sx={{ px: 2, py: 0 }}>
        <Box
          sx={{
            backgroundColor: "#FFFFFF",
            px: 3,
            py: 3,
            height: "calc(100vh - 90px)",
            overflowY: "auto",
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": {
              display: "none",
            },
          }}
        >
 
          <CustomText
            sx={{ ...textStyles.h1, fontSize: 18, fontWeight: 500, color: "#2C384C", textAlign: "left", pt: 3 }}
          >
            {t("filterDrawer.status")} {/* Add a translation key for Status */}
          </CustomText>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 2 }}>
         
            {statuses.map(({ label, value }) => {
  const isSelected = tempFilters.commission_status.includes(value)
  return (
    <Button
      key={value}
      onClick={() => {
        const updatedStatuses = isSelected
          ? tempFilters.commission_status.filter((s) => s !== value)
          : [...tempFilters.commission_status, value]
        setTempFilters({ ...tempFilters, commission_status: updatedStatuses })
      }}
           sx={{
                    borderRadius: "6px",
                    fontSize: "15px",
                    fontFamily: "Poppins, sans-serif",
                    textTransform: "none",
                    py: 0.8,
                    px: 2,
                    color: isSelected ? "#006EC2" : "#363333",
                    border: isSelected ? "2px solid #006EC2" : "2px solid #091E4224",
                    backgroundColor: "transparent",
                  }}
      // your existing styles...
    >
      {label}
    </Button>
  )
})}
          </Box>

          {/* Removed Max Users */}

          {/* Date Range */}
          <Box
            sx={{
              display: "flex",
              flexWrap: { xs: "wrap", sm: "nowrap" },
              gap: 2,
              mt: 3, // Adjusted margin top
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
              <label className="field_label">{t("filterDrawer.startDate")}</label>
              <input
                type="date"
                name="date_from"
                value={tempFilters.date_from}
                onChange={handleDateChange}
                className="project_input"
                style={{ width: "100%", height: 40 }}
              />
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
              <label className="field_label">{t("filterDrawer.endDate")}</label>
              <input
                type="date"
                name="date_to"
                value={tempFilters.date_to}
                onChange={handleDateChange}
                className="project_input"
                style={{ width: "100%", height: 40 }}
              />
            </Box>
          </Box>

                  <Box sx={{ mt: 4, display: 'flex',flexWrap:"wrap",gap: 2 }}>
            <CustomButton
            
 onClick={applyFilters}
       
              label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <img src={save} alt="save" style={{ width: 16, height: 16 }} />
                  {t("filterDrawer.save")}
                </Box>
              }
              size="medium"
            />
          
            <Button
              variant="outlined"
       onClick={clearAllFilters}
              sx={{
                fontSize: 15,
                textTransform: 'none',
                borderRadius: '5px',
                fontFamily: 'Poppins, sans-serif',
                color: '#006EC2',
                border: "2px solid #006EC2",
                px: 3,
                py: 1,
                height: 'fit-content',
              }}
            >
             {t("filterDrawer.clear")}
            </Button>
          </Box>
        </Box>
      </Box>
    </Drawer>
  )
}
export default FilterDrawer


